export default (prop) -> /^--/.test prop